import api from "./api";
import {
  FinancialCalendarQuery,
  FinancialCalendarResult,
  ProcessNumerary,
} from "../models/Financial";

export const getFinancialCalendar = async (
  filters: FinancialCalendarQuery,
  signal?: AbortSignal,
): Promise<FinancialCalendarResult> => {
  const response = await api.get("/api/financial/calendar", {
    params: filters,
    paramsSerializer: { indexes: null },
    signal,
  });
  return response.data;
};

export const exportFinancialWorkbook = async (
  model: "importProcesses" | "financialCalendar",
  filters: FinancialCalendarQuery,
) => {
  const response = await api.post("/api/financial/export", { model, filters }, { responseType: "blob" });
  const disposition = response.headers["content-disposition"] ?? "";
  const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  const plain = disposition.match(/filename="?([^";]+)"?/i)?.[1];
  const fileName = encoded ? decodeURIComponent(encoded) : plain ?? `${model}.xlsx`;
  const url = URL.createObjectURL(response.data);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};

export const getProcessNumeraries = async (processId: string): Promise<ProcessNumerary[]> =>
  (await api.get(`/api/process/${processId}/numeraries`)).data;

export const saveProcessNumerary = async (processId: string, numerary: Partial<ProcessNumerary>) =>
  numerary.id
    ? api.put(`/api/process/${processId}/numeraries/${numerary.id}`, numerary)
    : api.post(`/api/process/${processId}/numeraries`, numerary);

export const deleteProcessNumerary = async (processId: string, numeraryId: string) =>
  api.delete(`/api/process/${processId}/numeraries/${numeraryId}`);
